import type { WebSockets } from '@pushflow/types'
import { useModal } from '../../../hooks'
import { EModalName } from '../../../types/enums'
import { Scrollable } from '../../atoms'
import { ModalInputPassword } from '../../molecules'
import { LobbyFilter, TablesList } from '..'
import type { LobbyFilterType } from '../LobbyFilter'
import { lobby } from './index.css'

export const Lobby = (props: {
  type: 'PUBLIC' | 'PRIVATE'
  filter: LobbyFilterType
  onClickSit: (table: { id: string; password: string | null }) => void
  onFilterUpdate: (options: LobbyFilterType) => void
}) => {
  const { openModal } = useModal()

  const onClickSit = async (table: WebSockets.TableType) => {
    let password: null | string = null
    if (table.isPassworded) {
      const { closeModal } = openModal<string | undefined>(
        ({ close }) => <ModalInputPassword close={close} />,
        {
          title: 'Password required',
          closeOnClickOutside: true,
          name: EModalName.TABLE_PASSWORD_REQUEST,
        },
      )
      const result = await closeModal
      if (!result) {
        return
      }
      password = result
    }
    props.onClickSit({
      id: table.id,
      password,
    })
  }

  const onFilterUpdate = (options: LobbyFilterType) => {
    if (JSON.stringify(props.filter) !== JSON.stringify(options)) {
      props.onFilterUpdate(options)
    }
  }

  return (
    <div className={lobby}>
      <LobbyFilter
        options={props.filter}
        onUpdate={onFilterUpdate}
      />
      {/* <Scrollable> */}
      <TablesList
        type={props.type}
        {...props.filter}
        onClickSit={(table) => {
          void onClickSit(table)
        }}
      />
      {/* </Scrollable> */}
    </div>
  )
}
